import { ModalProps, ModalStatus } from "@/constants/modal";
import ModalModule from "@/store/modules/modal";
import { computed } from "vue";

/**
 * Returns a dialog visible computed property that is visible
 * only for a give status.
 * Also, when modifying the returned property, ModalModule will have
 * a hidden status
 * @param status
 */
export function dialogVisibleForStatus(status: ModalStatus) {
  return computed({
    get: () => {
      return ModalModule.status === status;
    },
    set: () => {
      if (ModalModule.status === status) {
        // prevent it from hiding other modals
        ModalModule.setStatus(ModalStatus.Hidden);
      }
    },
  });
}

export function hideDialog() {
  ModalModule.setStatus(ModalStatus.Hidden);
  if (ModalModule.modalProps.referrer && ModalModule.modalProps.goBack) {
    ModalModule.setStatus(ModalModule.modalProps.referrer);
  } else {
    ModalModule.setStatus(ModalStatus.Hidden);
  }
  ModalModule.setModalProps({ props: ModalModule.modalProps.props });
}

export function toggleModalVisible(item: ModalStatus) {
  ModalModule.setStatus(item);
}

/**
 * Open a modal that needs data, for example the check-in page.
 *
 * @param {ModalStatus} item - The modal to open.
 * @param {ModalProps["props"]} props - The data for that modal.
 * @returns {void}
 */
export function openModalWithProps(
  item: ModalStatus,
  props: ModalProps["props"]
): void {
  ModalModule.setModalProps({ props });
  ModalModule.setStatus(item);
}

// Computed property checking if they user shall logout after the modal is closed
export const shallLogout = computed(() => ModalModule.shallLogout);

// a method for clearing the shallLogout property
export function clearShallLogout() {
  ModalModule.setShallLogout(false);
}
